export const CountUpData = (data) => {
    return [
        {
            "id": "1",
            "start": "0",
            "end": `${data.agencyCount}`,
            "text": "تعداد نمایندگی ها"
        },
        {
            "id": "2",
            "start": "0",
            "end": `${data.userCount}`,
            "text": "تعداد کاربران"
        },
        {
            "id": "3",
            "start": "0",
            "end": `${data.deviceCount}`,
            "text": "دستگاه های آنلاین"
        },
        {
            "id": "4",
            "start": "0",
            "end": "99",
            "text": "درصد امنیت با ما"
        }
    ]
};